<template>
  <!-- IF LOADED -->
  <v-row
    no-gutters
    justify="center"
    style="height:50px;">
    <v-col
      cols="12"
      class="text-center">
      <v-alert
        justify="center"
        fixed="true"
        dense
        tile
        color="blue lighten-4 RescheduleToolbar">
        <span
          v-html="$t('reschedule.currentMeeting',
                     { date: `${startDate.format('ddd, MMM D')} ${formatHour(startDate, timezone)}-${formatHour(endDate, timezone, true)}`,
                       timezone: timezone })"/>
      </v-alert>
    </v-col>
  </v-row>
</template>
<script>
import { localeMixin, isMobileMixin } from '../mixins'

export default {
  mixins: [localeMixin, isMobileMixin],
  props: {
    timezone: {
      type: String,
      default: ''
    },
    startDate: {
      type: Object,
      default: null
    },
    endDate: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isEmbedded: null
    }
  }
}
</script>
<style lang="scss">
.RescheduleToolbar {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
